// THE MARK — a coral tile holding a cream "P." (Pressbooks: the press, and a full stop).
//
// Two strokes and a dot, so it survives 16px in a browser tab and scales cleanly to the
// login screen. The tile carries its own colour, so the mark reads the same on the cream
// page and the dark one — only the wordmark beside it follows the theme.
//
// The same drawing is public/favicon.svg (the tab icon); change them together.
import { useId } from 'react';
import he from '../i18n/he';

export function LogoMark({ size = 28 }) {
  // Unique per render: the mark can appear twice on one page (sidebar and top bar), and
  // two gradients sharing an id is one gradient silently reused.
  const id = `logo-${useId().replace(/:/g, '')}`;
  return (
    <svg className="logo-mark" width={size} height={size} viewBox="0 0 32 32" aria-hidden>
      <defs>
        <linearGradient id={id} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#F08A5D" />
          <stop offset="1" stopColor="#C24E2F" />
        </linearGradient>
      </defs>
      <rect width="32" height="32" rx="9" fill={`url(#${id})`} />
      <path d="M11.5 23.5V8.5h5.25a4.75 4.75 0 0 1 0 9.5H11.5" fill="none" stroke="#FFF8F2"
        strokeWidth="3.2" strokeLinecap="round" strokeLinejoin="round" />
      <circle cx="21.6" cy="22.4" r="2.1" fill="#FFF8F2" />
    </svg>
  );
}

// Mark + name. `size` is the mark's; the name follows the surrounding type.
export default function Logo({ size = 28, className = '' }) {
  return (
    <span className={`logo ${className}`}>
      <LogoMark size={size} />
      <span className="logo-name">{he.app}</span>
    </span>
  );
}
